import { connect } from 'react-redux';
import { selectors } from '../../Stream';
import { getCurrentUserHasCore, getTheme } from '../../publicSession/selectors';
import { saveBackground, previewBackground } from '../redux/actions';
import { getCurrentBackgroundId } from '../redux/selectors';
import { backgroundsStreamId } from '../redux/constants';
var mapStateToProps = function (state, _a) {
    var deviation = _a.deviation;
    return ({
        streamId: backgroundsStreamId,
        backgrounds: selectors.getItems(state, backgroundsStreamId),
        canUseCore: getCurrentUserHasCore(state),
        currentBackgroundId: getCurrentBackgroundId(state, deviation),
        isFetching: selectors.isFetching(state, backgroundsStreamId),
        theme: getTheme(state),
    });
};
var mapDispatchToProps = {
    onBackgroundPicked: saveBackground,
    onBackgroundPreviewed: previewBackground,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=BackgroundPickerPopup.container.js.map